<template>
  <el-dialog
    v-model="dialogVisible"
    class="henderC"
    :append-to-body="false"
    :close-on-click-modal="true"
    width="460"
    :before-close="handleClose"
  >
    <setShop
      :res-data="tenantList"
      :title-show="true"
      @ontenant-fn="ontenant"
    />
  </el-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { getTenantI18nConfig, tenantWitchApi, tenantListApi } from '@/api/login';
import { setTenantI18nConfigCache } from '@/utils/i18n';
import { getSafeRedirectPath } from '@/utils';
import router from '@/router';
import setShop from './setShop.vue';
const userStore = useUserStore();
const tenantList = ref([]);
const dialogVisible = ref(false);

/** 切换账号时按品牌、门店组、门店展示，与登录页顺序保持一致。 */
const tenantRelationTypeOrder: Record<string, number> = {
  data_brand: 0,
  data_shop_group: 1,
  data_shop: 2,
};
const dialogVisibleFn = () => {
  dialogVisible.value = true;
  initTenantList();
};
const initTenantList = async () => {
  // 获取租户
  await tenantListApi(true).then((res) => {
    tenantList.value = (res.data as any[]).map((tenant) => ({
      ...tenant,
      brandUserRelationList: [...(tenant.brandUserRelationList || [])].sort(
        (current, next) => (tenantRelationTypeOrder[current.type] ?? 99) - (tenantRelationTypeOrder[next.type] ?? 99),
      ),
    }));
  });
};
// 切换门店
const ontenant = async (item) => {
  await tenantWitchApi(item);
  userStore.settenantId(item.typeId);
  const { data } = await getTenantI18nConfig();
  setTenantI18nConfigCache(data);
  const redirectPath = getSafeRedirectPath(router.currentRoute.value.fullPath || '/');
  if (redirectPath === '/') {
    window.location.href = '/';
    return;
  }
  window.location.reload();
};
const handleClose = (done: () => void) => {
  done();
};
defineExpose({
  dialogVisibleFn,
});
</script>

<style lang="scss">
.henderC {
  border-radius: 10px;
  padding: 0 !important;

  .el-dialog__header {
    padding: 0 !important;
    border-bottom: none !important;
  }

  .shoptit {
    color: #555;
    font-size: 16px !important;
  }
}
</style>
